export class StripeCheckoutModel {
    public productId: string;
    public recurringTypeId: number;
}
